import {useState} from "react";
import {API_APARTMENT_SEARCH_RESORTS_SEARCH, API_APARTMENT_SEARCH_APARTMENT_CATEGORIES, API_APARTMENT_SEARCH_ALTERNATIVES} from "../common/api/apiConstants";
import {createURLQuery} from "../common/api/apiUtil";
import {apartmentSearchAPI} from "../common/api/apartmentSearchAPI";

export const useApartmentSearchAlternatives = () => {
    const [apartmentAlternatives, setApartmentAlternatives] = useState(null);
    const [loadingApartmentAlternatives, setLoadingApartmentAlternatives] = useState(false);
    const [error, setError] = useState(null);

    const loadApartmentAlternatives = (params) => {
        setLoadingApartmentAlternatives(true);
        setError(null);

        apartmentSearchAPI.get(API_APARTMENT_SEARCH_RESORTS_SEARCH + API_APARTMENT_SEARCH_APARTMENT_CATEGORIES + API_APARTMENT_SEARCH_ALTERNATIVES + createURLQuery(params))
            .then(res => res.data)
            .then(response => {
                response ? setApartmentAlternatives((response)) : setApartmentAlternatives({});
                setLoadingApartmentAlternatives(false);
            })
            .catch(err => {
                setApartmentAlternatives({});
                setError(err);
                setLoadingApartmentAlternatives(false);
            });

    };

    return {
        apartmentAlternatives,
        setApartmentAlternatives,
        loadApartmentAlternatives,
        loadingApartmentAlternatives,
        error
    };
};
